import { CircularProgress, Grid, TableCell, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
  rsTableLoadMore: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80px",
  },
}));

const TableLoadMore = (props) => {
  const { setRef } = props;

  const classes = useStyle();

  return (
    <>
      <TableRow>
        <TableCell colSpan={100}>
          <Grid ref={setRef} className={classes.rsTableLoadMore}>
            <CircularProgress />
          </Grid>
        </TableCell>
      </TableRow>
    </>
  );
};

export default TableLoadMore;
